<!--<div class="h-full min-h-full">-->
<!--    <p-card class="h-full">-->
<!--        <div class="flex align-items-center justify-content-between align-items-center mb-3">-->
<!--            <h4 class="m-0 text-2xl font-semibold">Vertrag Details</h4>-->
<!--            <p-button-->
<!--                    [text]="true"-->
<!--                    icon="pi pi-times"-->
<!--                    (click)="handleClose()">-->
<!--            </p-button>-->
<!--        </div>-->

<!--        <div class="flex flex-column gap-3">-->
<mvs-object
        objectType="cm.Contract"
        [objectId]="51355"
        uiMode="mini-side"
></mvs-object>
<!--            <div> contract: {{ contract | json }}</div>-->
<!--        </div>-->

<!--    </p-card>-->
<!--</div>-->